import { SiteUtilities } from './utils';
const init = (cloudTypeId) => {
  let qParam = SiteUtilities.getParameterByName('plan_id') || null;
  const $cloudTypeElement = $(cloudTypeId);
  const $defaultPrimaryNavLogo = $('.nav-primary-wrapper .nav-logo-wrapper').html();
  if (!$cloudTypeElement.length) { return; }
  const $form = $cloudTypeElement.closest('form');
  const $cloudTypeSelect = $cloudTypeElement.find('select');
  const defaultPlan = $($cloudTypeSelect).find('option')[0].value;
  const defaultEle = $($cloudTypeSelect).find('option')[0];
  let initDataLayer = false;
  let validParam = null;
  const $selectedCloudMsg = $cloudTypeElement.find('[data-nearest-center');
  $cloudTypeElement.find('.data-center-text').css('visibility', 'visible');
  $cloudTypeElement.find('[data-center-link]').on('click', function () {
    $cloudTypeElement.find('.field-dropdown').show().attr({
      'aria-hidden': 'false',
      tabindex: 0
    });
    $cloudTypeElement.find('.data-center-text').hide().attr({
      'aria-hidden': 'true',
      tabindex: -1
    });
  });

  const getHeadingElement = () => {
    const elements = [$($form).parent('.contact-form-wrapper').parent('.l-banner').find('h1'), $($form).parent().find('[data-form-heading] h4'), $($form).parent('.form-wrapper').parent('.form-overlap').parent('.l-page').find('h1')];
    for (const e of elements) {
      if (e.length) {
        return e;
      }
    }
    return null;
  };

  const headingEle = getHeadingElement($form);

  const updateAssetIdAndSubProduct = (ele) => {
    if (!ele) { return; }
    const assetId = $(ele).data('fm-asset-id') || null;
    const subProduct = $(ele).data('sub-product') || null;
    if (assetId) {
      $($form).find('.fm-asset-id').val(assetId);
      $form.data('fm_asset_id', assetId);
    }
    if (subProduct) {
      $form.data('sub_product', subProduct);
    }
  };

  const updatePrimaryNavLogo = (val) => {
    if (!val) { return; }
    if ($(`[data-primary-nav-logo-id="${val}"]`).length) {
      $('.nav-primary-wrapper .nav-logo-wrapper').empty().append($(`[data-primary-nav-logo-id="${val}"] > .product-logo-wrap`).clone());
    } else {
      $('.nav-primary-wrapper .nav-logo-wrapper').empty().append($defaultPrimaryNavLogo);
    }
  };

  const updateHeadingAndDropdown = (selectedEle, isInit = false, selectedVal) => {
    const heading = $(selectedEle).data('heading');
    const cloudType = $(selectedEle).data('cloud-type');
    $selectedCloudMsg.text($(selectedEle).text());
    if (headingEle) { $(headingEle).text(heading); }
    if (cloudType) { $form.data('cloud_type', cloudType); }
    setTimeout(() => {
      if (isInit) {
        $cloudTypeSelect.val(selectedVal).addClass('field-fix').trigger('change');
      } else {
        $cloudTypeSelect.val(selectedVal);
      }
    }, 0);
  };

  $cloudTypeSelect.on('change', function () {
    const planId = (this.value.split(',').length > 1) ? this.value.split(',')[0] : this.value;
    const val = $($cloudTypeSelect).find(`[value="${this.value}"]`);
    updateAssetIdAndSubProduct(val);
    updateHeadingAndDropdown(val, false, this.value);
    if ($('.signup-page-container').length || $('.signup-form-overlap').length) {
      updatePrimaryNavLogo(this.value);
    }
    $form.data('plan_id', planId);
    if (initDataLayer) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'PlanIDChanged', plan_id: planId });
    }
    initDataLayer = true;
  });

  const selectProductFromQueryParam = () => {
    if (!qParam) return;
    $(`${cloudTypeId} option`).each(function () {
      const val = $(this).val().split(',');
      for (const v of val) {
        if (v.trim() === qParam) {
          $form.data('plan_id', qParam);
          validParam = $(this);
          qParam = $(this).val();
          return;
        }
      }
    });
  };
  selectProductFromQueryParam();

  if (validParam) {
    updateAssetIdAndSubProduct(validParam);
    updateHeadingAndDropdown(validParam, true, qParam);
  } else {
    $form.data('plan_id', defaultPlan);
    const ele = $($cloudTypeSelect).find(`[value="${defaultPlan}"]`);
    updateAssetIdAndSubProduct(defaultEle);
    updateHeadingAndDropdown(ele, true, defaultPlan);
  }
};

export default { init };
